import axios from '@!/lib/axios'
import { buildUrlString } from '@!/Util'

export const getTopFeaturesApi = async (safeSearch, genreTabName, page) => {
  const params = {
    safe_search: safeSearch,
    page: page,
  }

  if (genreTabName) {
    params.genre_tab_name = genreTabName
  }

  const url = buildUrlString('/api/v1/features/top', params)

  return await axios.get(url)
}
